import docCookies from "../cookies";

if (document.querySelector(".site_notification--banner")) {
  var value = docCookies.getItem("site-banner");

  if (!value) {
    document
      .querySelector(".site_notification--banner")
      .classList.remove("hidden");
  } else {
    document
      .querySelector(".site_notification--banner")
      .classList.add("hidden");
  }

  document.querySelectorAll(".notification-close").forEach(item => {
    item.addEventListener("click", e => {
      document
        .querySelector(".site_notification--banner")
        .classList.add("hidden");
      console.log("close clicked");
      docCookies.setItem("site-banner", true, Infinity, "/");
    });
  });
}
